import { apiSlice } from "../app/api/apiSlice";

export const taxesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserTaxes: builder.query({
            query: ({user_id}) => `/user/taxes/${user_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Taxes']
        }),
        createUserTax: builder.mutation({
            query: (input) => ({
                url: `user/create-tax`,
                method: 'POST',
                body: { ...input }
            }),
            invalidatesTags: ['Taxes']
        }),
        editUserTax: builder.mutation({
            query: (input) => ({
                url: `user/edit-tax/${input.id}`,
                method: 'PUT',
                body: { ...input }
            }),
            invalidatesTags: ['Taxes']
        }),
        getTaxById: builder.query({
            query: (id) => `/user/tax/${id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Taxes']
        }),
        deleteTax: builder.mutation({
            query: (id) => ({
                url: `user/delete-tax/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Taxes']
        }),
    })
})

export const {
    useCreateUserTaxMutation,
    useEditUserTaxMutation,
    useGetUserTaxesQuery,
    useGetTaxByIdQuery,
    useDeleteTaxMutation,
} = taxesApiSlice

